// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__QQeIV","accordionTitle":"Accordion_accordionTitle__gR2B8","accordionContent":"Accordion_accordionContent__CXF1n","input":"Accordion_input__bTJfK"};